const getBreakpoint = cssVariableName => parseInt(getComputedStyle(document.documentElement).getPropertyValue(cssVariableName), 10)

const breakpoints = {
  tiny: getBreakpoint('--screen-size-tiny'),
  extraSmall: getBreakpoint('--screen-size-extra-small'),
  small: getBreakpoint('--screen-size-small'),
  medium: getBreakpoint('--screen-size-medium'),
  large: getBreakpoint('--screen-size-large'),
  extraLarge: getBreakpoint('--screen-size-extra-large'),
  ultraLarge: getBreakpoint('--screen-size-ultra-large'),
}

export default (breakpoint, whenSmaller, whenEqualOrLarger) => {
  const mediaQueryList = window.matchMedia( `(min-width: ${breakpoints[breakpoint]}px)`)
  return mediaQueryList.matches === false
    ? typeof whenSmaller === 'function'
      ? whenSmaller()
      : whenSmaller
    : typeof whenEqualOrLarger === 'function'
      ? whenEqualOrLarger()
      : whenEqualOrLarger
}